// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1242dcfc","732":"7cc60d9c","977":"d5bbbe13"}[chunkId] + ".chunk.js";
};